import React, {Component} from "react";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {Buffer} from "buffer";
import Cookies from "universal-cookie";
import {idealChatServices} from "../../services/ideal/IdealChatService";
import {Button, Spin, Comment, Avatar, Tooltip, Empty, Divider, Row, Col, Dropdown, Menu, Modal, Image, Result} from "antd";
import {AuditOutlined, WhatsAppOutlined, ReloadOutlined, ScheduleOutlined, IdcardOutlined, ApiOutlined} from "@ant-design/icons";
import moment from "moment";
import VerifyPhoneNumber from "./ideal_template/VerifyPhoneNumber";
import AskCustomerUpdateImage from "./ideal_template/AskCustomerUpdateImage";
import PoConfirm from "./ideal_template/PoConfirm";
import CreditConfirm from "./ideal_template/CreditConfirm";
import ConfirmCreditDoPo from "./ideal_template/ConfirmCreditDoPo";
import ConfirmCreditDoNetPo from "./ideal_template/ConfirmCreditDoNetPo";
import ConfirmCustomerShipment from "./ideal_template/ConfirmCustomerShipment";
import FetchDataIdeal from "./FetchDataIdeal";

class DetailOffer extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            chatData: [],
            init: false,
            loading: false,
            showModalVerifyPhoneNumber: false,
            showModalAskUpdateImage: false,
            showModalPoConfirm: false,
            showModalCreditConfirm: false,
            showModalSendConfirmCreditDpPo: false,
            showModalSendConfirmCreditDpNetPo: false,
            showModalSendConfirmCustomerShipment: false,
            showModalFetchIdeal: false,
            showModalConfirmCopyLocationPoint: false,
            doProcess: false,
            dataLatLng: {lat: "", lng: ""}
        }
        this.state = {...this.initState}
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.phoneNumber !== prevProps.phoneNumber) {
            await this.initChatHistory();
        }
    }

    async componentDidMount() {
        await this.initChatHistory();
    }

    initChatHistory = async () => {
        await this.promisedSetState({
            loading: false,
            chatData: [],
            init: true,
        });
    }

    showChatHistory = async () => {
        if (this.props.phoneNumber) {
            await this.promisedSetState({
                loading: true,
                init: false,
            });
            idealChatServices.getChatHistory({
                phoneNumber: this.props.phoneNumber,
            }).then(async value => {
                await this.promisedSetState({
                    loading: false,
                    chatData: value.data?.success?.data,
                    init: false,
                });
                this.scrollToBottom();
            }).catch(async e => {
                await this.promisedSetState({
                    loading: false,
                    chatData: [],
                    init: false,
                });
            });
        }
    }

    /*VERIFY PHONE NUMBER*/
    verifyPhoneNumber = async (data: any) => {
        console.log(data);
        await this.promisedSetState({
            showModalVerifyPhoneNumber: true,
        });
    }
    successModalVerifyPhoneNumber = (data: any) => {
        this.setState({
            showModalVerifyPhoneNumber: false,
        });
        this.showChatHistory();
    }
    /*VERIFY PHONE NUMBER*/

    /*LINK UPLOAD IMAGE*/
    sendLinkUploadImage = async (data: any) => {
        console.log(data);
        await this.promisedSetState({
            showModalAskUpdateImage: true,
        })
    }
    successModalAskUpdateImage = (data: any) => {
        this.setState({
            showModalAskUpdateImage: false,
        });
        this.showChatHistory();
    }
    /*LINK UPLOAD IMAGE*/

    /*CONFIRM PO*/
    sendConfirmPo = async (data: any) => {
        console.log(data);
        await this.promisedSetState({
            showModalPoConfirm: true,
        })
    }
    successModalConfirmPo = (data: any) => {
        this.setState({
            showModalPoConfirm: false,
        });
        this.showChatHistory();
    }
    /*CONFIRM PO*/

    /*CONFIRM CREDIT*/
    sendConfirmCredit = async (data: any) => {
        console.log(data);
        await this.promisedSetState({
            showModalCreditConfirm: true,
        })
    }
    successModalConfirmCreditA = (data: any) => {
        this.setState({
            showModalCreditConfirm: false,
        });
        this.showChatHistory();
    }
    /*CONFIRM CREDIT*/

    /*CONFIRM Order CREDIT DP PO*/
    sendConfirmCreditDpPo = async (data: any) => {
        console.log(data);
        await this.promisedSetState({
            showModalSendConfirmCreditDpPo: true,
        })
    }
    successModalConfirmCreditDpPo = (data: any) => {
        this.setState({
            showModalSendConfirmCreditDpPo: false,
        });
        this.showChatHistory();
    }
    /*CONFIRM Order CREDIT DP PO*/

    /*CONFIRM Order CREDIT DP NET*/
    sendConfirmCreditDpNetPo = async (data: any) => {
        await this.promisedSetState({
            showModalSendConfirmCreditDpNetPo: true,
        })
    }
    successModalConfirmCreditDpNetPo = (data: any) => {
        this.setState({
            showModalSendConfirmCreditDpNetPo: false,
        });
        this.showChatHistory();
    }
    /*CONFIRM Order CREDIT DP NET*/

    successModalConfirmCustomerShipment = (data: any) => {
        this.setState({
            showModalSendConfirmCustomerShipment: false,
        });
        this.showChatHistory();
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    scrollToBottom() {
        const chatContainer = document.getElementById("chat-container");
        if (chatContainer) {
            const lastChild: any = chatContainer.lastChild;
            if (lastChild) {
                lastChild.scrollIntoView({behavior: "smooth"});
            }
        }
    }

    fetchIdealData() {
        this.setState({
            showModalFetchIdeal: true,
        })
    }

    successModalFetchIdeal = (data: any) => {
        this.setState({
            showModalFetchIdeal: false,
        });
        this.props.onCloseProps("reload");
    }

    confirmPointLocation = async () => {
        await this.promisedSetState({
            doProcess: true,
        });

        const dataUpdate = {
            update_type: "address-point-shipping",
            company: "AMARTA",
            admin_id: this.user,
            admin_name: this.user,
            dealer_code: "",
            offer_code: this.props.dataOffer?.transaction_code,
            address_shipping: {
                location_point: {
                    point: `${this.state.dataLatLng.lat},${this.state.dataLatLng.lng}`,
                    lat: this.state.dataLatLng.lat,
                    lng: this.state.dataLatLng.lng,
                }
            }
        };

        try {
            await offerApiServices.updateOffer(dataUpdate)
                .then(successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Offer berhasil di update '
                    });
                    this.setState({
                        doProcess: false,
                        showModalConfirmCopyLocationPoint: false,
                    });
                    this.props.onCloseProps("reload");
                });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: '' + e
            });
            await this.promisedSetState({
                doProcess: false,
            });
        }
    }

    render() {
        const menu = (
            <Menu>
                <Menu.Item key={0}>
                    <span onClick={event => this.fetchIdealData()} style={{cursor: "pointer"}}> <ApiOutlined/> Lihat Data IDEAL</span>
                </Menu.Item>
                <Menu.Divider/>
                <Menu.Item key={1}>
                    <span onClick={event => this.verifyPhoneNumber(this.props.dataOffer)} style={{cursor: "pointer"}}> <WhatsAppOutlined/> Verifikasi Nomor Telpon</span>
                </Menu.Item>
                <Menu.Item key={2}>
                    <span onClick={event => this.sendLinkUploadImage(this.props.dataOffer)} style={{cursor: "pointer"}}> <IdcardOutlined/> Link Upload Dokumen Kepemilikan</span>
                </Menu.Item>
                <Menu.Item key={3}>
                    <span onClick={event => this.sendConfirmCredit(this.props.dataOffer)} style={{cursor: "pointer"}}> <AuditOutlined/> Konfirmasi Kredit</span>
                </Menu.Item>
                <Menu.Item key={4}>
                    <span onClick={event => this.sendConfirmPo(this.props.dataOffer)} style={{cursor: "pointer"}}> <AuditOutlined/> Konfirmasi Kendaraan PO</span>
                </Menu.Item>
                <Menu.Item key={5}>
                    <span onClick={event => this.sendConfirmCreditDpPo(this.props.dataOffer)} style={{cursor: "pointer"}}> <AuditOutlined/> Konfirmasi Order <b>Kredit</b> DP PO</span>
                </Menu.Item>
                <Menu.Item key={6}>
                    <span onClick={event => this.sendConfirmCreditDpNetPo(this.props.dataOffer)} style={{cursor: "pointer"}}> <AuditOutlined/> Konfirmasi Order <b>Kredit</b> DP PO Net <i style={{fontSize: "70%", color: "grey"}}>(DP PO - Promo)</i></span>
                </Menu.Item>
                <Menu.Item key={7}>
                    <span onClick={event => this.setState({showModalSendConfirmCustomerShipment: true})} style={{cursor: "pointer"}}> <AuditOutlined/> Konfirmasi Kesiapan Penerimaan Unit</span>
                </Menu.Item>
            </Menu>
        );
        return (
            <React.Fragment>
                <div style={{padding: "10px"}}>
                    <Row>
                        <Col xs={12} xl={12}>
                            <i className={`col-grey`}>Nomor Telpon Pemilik:</i><br/>
                            {this.props.phoneNumber}
                        </Col>
                        <Col xs={12} xl={12} style={{paddingTop: "15px"}}>
                            <Button disabled={true} onClick={this.showChatHistory} style={{float: "right", marginLeft: "10px"}} type="primary" size={"small"} icon={<ReloadOutlined/>}/>
                            <Dropdown overlay={menu} placement="bottomLeft" arrow>
                                <Button style={{float: "right"}} size={"small"} type={"primary"}> <ScheduleOutlined/> Aksi</Button>
                            </Dropdown>
                        </Col>
                    </Row>

                    <Divider/>

                    <div style={this.state.loading ? {textAlign: "center", padding: 20, minHeight: 200} : {display: 'none'}}>
                        <Spin style={{marginTop: 20}} size={'large'} tip="Loading..."/>
                    </div>

                    <div style={this.state.init ? {} : {display: 'none'}}>
                        <Result
                            title="Klik Reload untuk melihat isi chat"
                            subTitle="anda dapat melihat data konsumen IDEAL dan mengirim template konfirmasi chat dengan memilih template pada tombol Aksi. "
                            extra={[
                                <Button disabled={true} onClick={this.showChatHistory} type="primary" icon={<ReloadOutlined/>}> Load Percakapan</Button>
                            ]}
                        />
                    </div>

                    <div style={!this.state.loading && !this.state.init && this.state?.chatData?.length < 1 ? {} : {display: 'none'}}>
                        <Empty/>
                    </div>

                    <div id="chat-container" style={!this.state.loading ? {maxHeight: "500px", overflow: "scroll"} : {display: 'none'}}>
                        {this.state.chatData?.map((item: any, i: number) =>
                            <Comment
                                key={i}
                                author={(item.direction === "OUT") ? (item?.name !== "SYSTEM_REPLY") ? "SYSTEM_REPLY" : "Admin" : item?.name}
                                avatar={<Avatar>{item?.name?.toUpperCase()?.substring(0, 1)}</Avatar>}
                                content={<p style={{fontSize: "80%", wordSpacing: "2px"}}>
                                    {item?.text?.body}
                                    {item?.interactive?.body?.text} {item?.interactive?.list_reply?.title} {item?.interactive?.button_reply?.title} {item?.button?.text}
                                    {item?.image?.link && (<div><Image width={200} src={item?.image?.link}/><br/></div>)}
                                    {item?.image?.caption}
                                    <div style={item?.location ? {} : {display: 'none'}}>
                                        <Row>
                                            <Col span={14}>
                                                Location<br/>
                                                <a href={`https://www.google.com/maps/search/${item?.location?.latitude},${item?.location?.longitude}`} target="_blank" rel="noopener noreferrer">
                                                    {item?.location?.latitude},{item?.location?.longitude}
                                                </a>
                                            </Col>
                                            <Col span={10} style={this.props.dataOffer?.offer_status === "OPEN" ? {} : {display: 'none'}}>
                                                <Button onClick={() => this.setState({showModalConfirmCopyLocationPoint: true, dataLatLng: {lat: item?.location?.latitude, lng: item?.location?.longitude}})} style={{float: "right", marginRight: 10, fontSize: "80%"}} size={"small"}>Jadikan Point Pengiriman</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </p>}
                                datetime={
                                    <Tooltip title={moment(item?.time).format('YYYY-MM-DD HH:mm:ss')}>
                                        <span>{moment(item?.time).fromNow()}</span>
                                    </Tooltip>
                                }
                            />
                        )}
                    </div>

                </div>

                <Modal
                    open={this.state.showModalVerifyPhoneNumber}
                    title="Verifikasi Nomor Telpon"
                    onOk={() => this.setState({showModalVerifyPhoneNumber: false})}
                    onCancel={() => this.setState({showModalVerifyPhoneNumber: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <VerifyPhoneNumber
                        onCloseProps={this.successModalVerifyPhoneNumber}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalAskUpdateImage}
                    title="Kirim Link Upload Dokumen Kepemilikan"
                    onOk={() => this.setState({showModalAskUpdateImage: false})}
                    onCancel={() => this.setState({showModalAskUpdateImage: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <AskCustomerUpdateImage
                        onCloseProps={this.successModalAskUpdateImage}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalPoConfirm}
                    title="Konfirmasi Kendaraan PO"
                    onOk={() => this.setState({showModalPoConfirm: false})}
                    onCancel={() => this.setState({showModalPoConfirm: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <PoConfirm
                        onCloseProps={this.successModalConfirmPo}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                        urlImageCatalogue={this.props.urlImageCatalogue ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalCreditConfirm}
                    title="Konfirmasi Kredit"
                    onOk={() => this.setState({showModalCreditConfirm: false})}
                    onCancel={() => this.setState({showModalCreditConfirm: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <CreditConfirm
                        onCloseProps={this.successModalConfirmCreditA}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                        urlImageCatalogue={this.props.urlImageCatalogue ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalSendConfirmCreditDpPo}
                    title="Konfirmasi Order Kredit DP PO"
                    onOk={() => this.setState({showModalSendConfirmCreditDpPo: false})}
                    onCancel={() => this.setState({showModalSendConfirmCreditDpPo: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <ConfirmCreditDoPo
                        onCloseProps={this.successModalConfirmCreditDpPo}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                        urlImageCatalogue={this.props.urlImageCatalogue ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalSendConfirmCreditDpNetPo}
                    title="Konfirmasi Order Kredit DP PO NET"
                    onOk={() => this.setState({showModalSendConfirmCreditDpNetPo: false})}
                    onCancel={() => this.setState({showModalSendConfirmCreditDpNetPo: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <ConfirmCreditDoNetPo
                        onCloseProps={this.successModalConfirmCreditDpNetPo}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                        urlImageCatalogue={this.props.urlImageCatalogue ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalSendConfirmCustomerShipment}
                    title="Konfirmasi Ketersidaan Customer Untuk Menerimta Unit"
                    onOk={() => this.setState({showModalSendConfirmCustomerShipment: false})}
                    onCancel={() => this.setState({showModalSendConfirmCustomerShipment: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <ConfirmCustomerShipment
                        onCloseProps={this.successModalConfirmCustomerShipment}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.props.phoneNumber ?? ""}
                        urlImageCatalogue={this.props.urlImageCatalogue ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalFetchIdeal}
                    title={`Data Ideal - ${this.props.phoneNumber}`}
                    onOk={() => this.setState({showModalFetchIdeal: false})}
                    onCancel={() => this.setState({showModalFetchIdeal: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[]}
                >
                    <FetchDataIdeal
                        onCloseProps={this.successModalFetchIdeal}
                        offerData={this.props.dataOffer}
                        offerCode={this.props.dataOffer?.transaction_code}
                        phoneNumber={this.props.phoneNumber ?? ""}
                        time={Math.floor(+new Date() / 1000)}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalConfirmCopyLocationPoint}
                    title="Konfirmasi Point Pengiriman"
                    onOk={() => this.setState({showModalConfirmCopyLocationPoint: false})}
                    cancelText={'Tutup'} okText={false}
                    maskClosable={false}
                    closable={false}
                    footer={[
                        <Button onClick={this.confirmPointLocation} type={"primary"} loading={this.state.doProcess} key="1">Jadikan Point Pengiriman</Button>,
                        <Button loading={this.state.doProcess} key="2" onClick={() => this.setState({showModalConfirmCopyLocationPoint: false})}>Close</Button>,
                    ]}
                >
                    Anda Yakin Akan menjadikan point koordinat tersebut sebagai point koordinat pengiriman ? <br/><br/>
                </Modal>
            </React.Fragment>
        );
    }
}

export default DetailOffer;